<template>
  <div>
    <b-row
      v-if="
        hasRecibo &&
          (USER().rol === ROLES.SUPER ||
            USER().rol === ROLES.ADMIN ||
            USER().rol === ROLES.TESORERIA)
      "
    >
      <b-col md="12" class="d-flex justify-content-center align-items-center"
        ><b-form-checkbox v-model="pagadoAux" name="check-button" switch>
          Pagado
        </b-form-checkbox></b-col
      >
    </b-row>
    <b-row v-if="!pagadoAux && hasRecibo" class="d-flex justify-content-center">
      <b-alert variant="danger" show>
        <div class="alert-body p-0 d-flex justify-content-center">
          <span style="font-size:11px; padding:5px;font-weight: bold;">
            <b>Atención:</b> Debes marcar como pagado para que los datos tengan
            influencia sobre los abonos y saldos
          </span>
        </div>
      </b-alert>
    </b-row>
    <b-row
      style="margin-left: 0px; margin-right: 0px; background-color:#3e3d3d; color:white; font-size:13px; padding:9px; border-radius:3px;"
    >
      <b-col md="12" class="d-flex justify-content-center">
        <div><b>Detalle del Recibo</b></div>
      </b-col>
      <div>
        <span style="font-size:11px; color:orange"
          >Valores en color tomate no ingresan a arcas de Liga, son fijos</span
        >
      </div>
      <!-- <b-col md="12">Recibo #: {{ dataRecibo.numRecibo }}</b-col>
      <b-col md="12">Fecha emisión: {{ dataRecibo.fechaEmision }}</b-col> -->
    </b-row>
    <b-row
      class="mt-0 border"
      style="margin-left: 0px; margin-right: 0px;background-color:#3e3d3d; color:white; font-size:12px; padding:7px;"
    >
      <b-col md="1" class="d-flex justify-content-center">Can</b-col>
      <b-col md="6">
        Concepto
      </b-col>
      <b-col md="2">
        V.U
      </b-col>
      <b-col md="2" style="text-align:center">
        V.T
      </b-col>
      <b-col md="1"> </b-col>
    </b-row>
    <b-overlay
      :show="loading"
      :style="loading ? 'margin-top:40px;' : 'margin-top:0px;'"
    >
      <div style="overflow-y: auto; max-height:40vh;">
        <b-row
          v-for="item in listDetalle"
          :key="item.id"
          class="mt-0 ml-0 mr-0"
          style="font-size: 12px; padding: 5px; border-top: 1px solid #3e3d3d; background-color:#efefef"
        >
          <b-col
            md="1"
            class="d-flex justify-content-center align-items-center text-secondary"
          >
            {{ item.cantidad }}
          </b-col>
          <b-col md="6" class="d-flex p-0 align-items-center">
            <span
              >{{ item.concepto_final }}
              <!-- <span
            v-if="item.concepto_dividir !== '' && item.concepto_dividir != null"
          >
            ({{ item.concepto_dividir }})</span
          > -->
            </span>
          </b-col>
          <b-col
            md="2"
            class="d-flex justify-content-center align-items-center"
          >
            {{ item.v_unitario }}
          </b-col>
          <b-col
            md="2"
            class="d-flex justify-content-center align-items-center"
            style="width: 12%; text-align: right; font-size: 14px;"
          >
            {{ item.v_total }}
          </b-col>
          <b-col
            md="1"
            class="d-flex justify-content-center align-items-center"
            style="width: 12%; text-align: right; font-size: 14px;"
          >
            <span style="font-size:11px; background:#fff2e7;padding:3px">{{
              item.id_dividir_multa != null ? item.pagada_dividir : item.pagada
            }}</span>
          </b-col>
          <b-col md="1" class="d-flex p-0">
            <b-button
              v-if="!hasRecibo"
              @click="eliminarDetalle(item)"
              variant="flat-danger"
              class="btn-icon"
              size="sm"
            >
              <feather-icon size="14" icon="XIcon" />
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-overlay>
    <b-row
      style="margin-left: 0px;font-size:13px; margin-right: 0px;background: #636161; color:white; padding:10px;font-weight: bolder;position: sticky;"
    >
      <b-col md="7">TOTAL RECIBO</b-col>
      <b-col md="4"
        ><span style="float:right;margin-right:10px"
          >{{ totalRecibo }}<span>$</span></span
        ></b-col
      >
    </b-row>
    <b-row
      v-for="fijo in listFijos"
      :key="fijo.id"
      style="margin-left: 0px; font-size:13px;margin-right: 0px;background: #636161; color:orange;padding: 10px;font-weight: bolder;position: sticky;"
    >
      <b-col md="7">{{ fijo.descripcion }}</b-col>
      <b-col md="4"
        ><span style="float:right;margin-right:10px"
          >{{ fijo.valor }}<span>$</span></span
        ></b-col
      >
    </b-row>
    <b-row
      style="margin-left: 0px; font-size:18px;margin-right: 0px;background: #636161;color:#f2fe3e;padding: 10px;font-weight: bolder;position: sticky;"
    >
      <b-col md="7">TOTAL </b-col>
      <b-col md="4"
        ><span style="float:right;margin-right:10px"
          >{{ Number(totalRecibo) + Number(totalFijo) }}<span>$</span></span
        ></b-col
      >
    </b-row>
    <b-row
      v-if="pagadoAux && hasRecibo"
      class="d-flex justify-content-center"
      style="margin-left: 0px;margin-right: 0px; text-align: center;background-color: #0cbd7b;color: white;font-size: 23px;font-weight: bold;"
    >
      <b-col md="12">
        <div style="width:100%">
          Pagado
        </div>
      </b-col>
      <div style="font-size:10px">
        {{ dataReciboCabecera.fecha_pago }} -
        {{ dataReciboCabecera.nombreComPaga }}
      </div>
    </b-row>
    <b-row v-if="hasRecibo" style="margin-top: 10px;font-size: 13px"
      ><b-col md="12"
        >Generado {{ dataReciboCabecera.fecha }} por
        {{ dataReciboCabecera.nombreCom }}</b-col
      ></b-row
    >
  </div>
</template>
<script>
import { computed } from '@vue/composition-api'
import {
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BAlert,
  BOverlay,
  // BBadge,
  //   xxx ,
} from 'bootstrap-vue'
import {
  // URL,
  USER,
  ROLES,
  // xxx,
} from '../../utils/variables'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    BAlert,
    BOverlay,
    // BBadge,
  },
  props: {
    listDetalle: Array,
    dataRecibo: Object,
    dataReciboCabecera: Object,
    listFijos: Array,
    bloquearRecibo: String,
    hasRecibo: Boolean,
    isReciboPagado: Boolean,
    arbitraje: String,
    delVocal: String,
    loading: Boolean,
    totalRecibo: String,
    totalFijo: String,
    total: String,
  },
  setup(props, { emit }) {
    const pagadoAux = computed({
      get: () => props.isReciboPagado,
      set: value => {
        // props.isManualProp = value
        emit('marcarPagado', value)
      },
    })
    function quitarArray(item) {
      const found = props.listDetalle.findIndex(
        // eslint-disable-next-line
        element => element.idAux === item.idAux
      )
      props.listDetalle.splice(found, 1)
    }
    // function marcarPagado() {
    //   console.log('aquii')
    //   // emit('marcarPagado', props.listDetalle)
    // }

    function eliminarDetalle(item) {
      quitarArray(item)
      emit('ponerEnPendientes', item)
    }
    return {
      eliminarDetalle,
      // marcarPagado,
      USER,
      ROLES,
      pagadoAux,
    }
  },
}
</script>
